import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { getCategoryById } from '../config/magazineConfig';
import { getInstitution, getInstitutionTailwind } from '../config/institutionConfig';

const CategoryPage = () => {
  const { categoryId } = useParams();
  const category = getCategoryById(categoryId);
  const institution = getInstitution();
  const tw = getInstitutionTailwind();

  // Si no se encuentra la categoría, mostrar error
  if (!category) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex flex-col items-center justify-center p-8">
        <div className="bg-white rounded-2xl shadow-xl p-12 text-center max-w-md border border-gray-100">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-red-100 to-red-200 rounded-full mb-6">
            <svg className="h-8 w-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-3">
            Categoría no encontrada
          </h1>
          <p className="text-gray-600 mb-6">
            La categoría que buscas no está disponible o no existe.
          </p>
          <Link
            to="/"
            className={`inline-block px-6 py-3 bg-gradient-to-r ${tw.buttonGradient} text-white rounded-lg ${tw.buttonHoverGradient} transition-all transform hover:scale-105 shadow-lg`}
          >
            Volver al inicio
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
      {/* Header con diseño mejorado */}
      <header className="app-header relative overflow-hidden">
        {/* Efecto de fondo decorativo */}
        <div className="absolute inset-0 opacity-90" style={{
          background: `linear-gradient(to right, var(--color-primary-dark), var(--color-primary), var(--color-primary-dark))`
        }}></div>
        <div className="absolute inset-0 bg-pattern opacity-10"></div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '16px'
          }}>
            {/* Logo con efecto */}
            <div style={{ flexShrink: 0 }} className="transform hover:scale-105 transition-transform">
              <img
                src={`${process.env.PUBLIC_URL}${institution.logo}`}
                alt={`Logo ${institution.shortName}`}
                className="app-logo"
                style={{ height: '56px', filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.2))' }}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
            {/* Título mejorado */}
            <div>
              <h1 
                style={{
                  color: '#ffffff',
                  fontSize: '32px',
                  fontWeight: '800',
                  margin: '0',
                  letterSpacing: '0.5px',
                  textShadow: '0 2px 8px rgba(0,0,0,0.3)'
                }}
              >
                {category.name}
              </h1>
              <p style={{
                color: 'rgba(255, 255, 255, 0.9)',
                fontSize: '15px',
                margin: '6px 0 0 0',
                fontWeight: '400',
                textShadow: '0 1px 2px rgba(0,0,0,0.2)'
              }}>
                {category.description}
              </p>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Breadcrumb */}
        {/* <nav className="mb-8 flex items-center text-sm">
          <Link to="/" className="text-blue-600 hover:text-blue-800 font-medium transition-colors">
            Centro de Publicaciones
          </Link>
          <svg className="h-4 w-4 mx-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
          <span className="text-gray-600">{category.name}</span>
        </nav> */}

        <div className="mb-10 text-center">
          <h2 className={`text-3xl font-bold bg-gradient-to-r ${tw.titleGradient} bg-clip-text text-transparent mb-3`}>
            Publicaciones Disponibles
          </h2>
          <p className="text-gray-600 text-lg">
            Haz clic en una publicación para visualizarla de manera interactiva
          </p>
        </div>

        {/* Lista de publicaciones */}
        {category.magazines.length === 0 ? (
          <div className="bg-white rounded-2xl shadow-lg p-12 text-center border border-gray-100">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-100 to-purple-100 rounded-full mb-6">
              <svg 
                className="h-8 w-8 text-blue-600 flex-shrink-0" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
                />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              No hay publicaciones disponibles
            </h3>
            <p className="text-gray-500 text-base">
              Aún no hay publicaciones en esta categoría
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {category.magazines.map((magazine) => (
              <Link
                key={magazine.id}
                to={`/${categoryId}/${magazine.id}`}
                className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100 transform hover:-translate-y-2"
              >
                {/* Card Header con gradiente */}
                <div className="h-40 bg-gradient-to-br from-blue-500 via-purple-500 to-pink-500 relative overflow-hidden">
                  <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <svg 
                      className="h-16 w-16 text-white opacity-60 group-hover:opacity-90 transform group-hover:scale-110 transition-all duration-300" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth={1.5} 
                        d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" 
                      />
                    </svg>
                  </div>
                </div>

                {/* Card Body */}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors">
                    {magazine.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                    {magazine.description}
                  </p>
                  
                  {/* Ver publicación button */}
                  <div className="flex items-center text-blue-600 font-semibold text-sm group-hover:text-purple-600 transition-colors">
                    <span>Ver publicación</span>
                    <svg 
                      className="ml-2 h-4 w-4 transform group-hover:translate-x-1 transition-transform" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}

        {/* Botón volver */}
        {/* <div className="mt-12 text-center">
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 bg-white text-gray-700 rounded-lg hover:bg-gray-50 transition-all shadow-md hover:shadow-lg border border-gray-200"
          >
            <svg className="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Volver al Centro de Publicaciones
          </Link>
        </div> */}
      </main>
    </div>
  );
};

export default CategoryPage;
